import actionCreator from 'utils/actionCreator';

export const actions = actionCreator('team', [
  'RESET',
  'TEAMS_REQUEST',
  'TEAMS_SUCCESS',
  'CANCEL_TEAMS_LISTENER',
  'CREATE_TEAM',
  'UPDATE_TEAM',
  'TOGGLE_TEAM_ADD_MODAL',
  'REMOVE_FROM_TEAM',
  'UPDATE_THEME',
  'UPDATE_TEAM_NAME',
  'UPDATE_CUSTOM_DOMAIN',
]);

export const resetTeam = () => ({
  type: actions.RESET,
});

export const teamsRequest = () => ({
  type: actions.TEAMS_REQUEST,
});

export const teamsSuccess = (payload) => ({
  type: actions.TEAMS_SUCCESS,
  payload,
});

export const cancelTeamsListener = () => ({
  type: actions.CANCEL_TEAMS_LISTENER,
});

export const createTeam = (payload, callback) => ({
  type: actions.CREATE_TEAM,
  payload,
  callback,
});

export const updateTeam = (payload, callback) => ({
  type: actions.UPDATE_TEAM,
  payload,
  callback,
});

export const toggleTeamAddModal = () => ({
  type: actions.TOGGLE_TEAM_ADD_MODAL,
});

export const removeFromTeam = (payload) => ({
  type: actions.REMOVE_FROM_TEAM,
  payload,
});

export const updateTheme = (payload, callback) => ({
  type: actions.UPDATE_THEME,
  payload,
  callback,
});

export const updateTeamName = (payload) => ({
  type: actions.UPDATE_TEAM_NAME,
  payload,
});

export const updateCustomDomain = (payload, callback) => ({
  type: actions.UPDATE_CUSTOM_DOMAIN,
  payload,
  callback,
});
